import React from "react";
import Lesson from "./Lesson";
import Card from "react-bootstrap/Card";
import { Row } from "react-bootstrap";

// Lesson list; contains Lesson components

/**
 * Populates a list of lessons with the lesson information
 * @returns
 */
const LessonList = () => {
  // const [userType, setUserType] = useState('student');

  const first = {
    title: "Introduction to Stable Diffusion",
    length: "30 Minutes",
    description:
      "This lesson will cover the basics of Stable Diffusion and its key concepts.",
    topics: ["Image Generation", "Stable Diffusion", "Artificial Intelligence"],
    page: "../lessons/first",
  };

  const second = {
    title: "Prompt Suggestions and Styles",
    length: "15 Minutes",
    description:
      "This lesson will go over the usage of prompt suggestions and styles.",
    topics: ["Prompt Suggestions", "Styles"],
    page: "../lessons/second",
  };

  const third = {
    title: "Advanced Options",
    length: "30 Minutes",
    description: "This lesson will go over the advanced options toggle.",
    topics: ["Advanced Options", "Seeds", "Steps", "Guidance Scale"],
    page: "../lessons/third",
  };

  const fourth = {
    title: "Bias Correction",
    length: "15 minutes",
    description:
      "This lesson will go over bias correction and why it is important in an AI image generator",
    topics: ["Bias", "Diversity"],
    page: "../lessons/fourth",
  };

  return (
    <div>
      <Card>
        <Card.Header
          className="bg-success text-white"
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "5px",
          }}
        >
          <h3>Lessons</h3>
        </Card.Header>
        <Row>
          <Lesson
            user="student"
            title={first.title}
            length={first.length}
            description={first.description}
            topics={first.topics}
            page={first.page}
          />
        </Row>
        <Row>
          <Lesson
            user="student"
            title={second.title}
            length={second.length}
            description={second.description}
            topics={second.topics}
            page={second.page}
          />
        </Row>
        <Row>
          <Lesson
            user="student"
            title={third.title}
            length={third.length}
            description={third.description}
            topics={third.topics}
            page={third.page}
          />
        </Row>
        <Row>
          <Lesson
            user="student"
            title={fourth.title}
            length={fourth.length}
            description={fourth.description}
            topics={fourth.topics}
            page={fourth.page}
          />
        </Row>
      </Card>
    </div>
  );
};

export default LessonList;
